<template>
  <RouterLink
    v-slot="{ href, navigate, isActive }"
    :to="to()"
    custom
  >
    <a
      class="text-center relative hover:no-underline"
      :style="`flex-basis: ${width}%;`"
      :href="href"
      @click="navigate"
    >
      <MenuItemIconText
        :title="title"
        :icon="icon"
        :active-icon="activeIcon"
        :unread-hints="unreadHints"
        :is-active="isActive"
      />
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import { RouterLink } from 'vue-router';
import MenuItemIconText from "@/application/menu/components/MenuItemIconText.vue";

interface Props {
  title: string,
  icon: string | string[],
  activeIcon: string | string[],
  to: (() => RouteLocationRaw),
  unreadHints: number | null,
  width: number,
}

defineProps<Props>();
</script>
